export default __webpack_public_path__ + "static/media/3.353ae8b6.png";